import type { SettingsTranslations } from "@/lib/i18n/types/settings";

/**
 * The chatbot write tools whose auto-approve ("Always allow") preference a user
 * can manage from /settings (WHA-3652).
 *
 * `name` is the backend tool identifier stored in
 * `user_chatbot_tool_preferences.tool_name`. This list MUST stay in sync with:
 *   - backend `chatbot/tool_preferences.py:ALLOWED_TOOL_NAMES`
 *   - `KNOWN_TOOL_NAMES` in
 *     `src/components/chat/SidebarChat/BuildingDataConfirmationCard.tsx`
 * Adding an auto-approvable tool means adding it in all three places.
 */
export interface ChatbotToolMeta {
  name: string;
  /** Key into `t.settings.chatbotSettings.tools`. */
  copyKey: keyof SettingsTranslations["chatbotSettings"]["tools"];
}

export const CHATBOT_AUTO_APPROVE_TOOLS: readonly ChatbotToolMeta[] = [
  { name: "update_building_data", copyKey: "updateBuildingData" },
  { name: "create_pm_issue", copyKey: "createPmIssue" },
  { name: "update_pm_issue", copyKey: "updatePmIssue" },
  { name: "add_pm_issue_comment", copyKey: "addPmIssueComment" },
  { name: "add_file_to_folder", copyKey: "addFileToFolder" },
  { name: "set_document_verified", copyKey: "setDocumentVerified" },
] as const;
